 var local_key = 'INDICATION_KEY';

 import {
   paths
 } from '@/components/indication/'

 function fetchData() {
   const INDICATION_KEY = localStorage.getItem(local_key);
   var local_info = null;
   try {
     local_info = INDICATION_KEY ? JSON.parse(INDICATION_KEY) : []
   } catch (e) {
     local_info = []
   }
   return local_info;
 }


 export function firstAssign() {
   localStorage.setItem(local_key, JSON.stringify(Object.keys(paths)))
 }


 export function removeItem(key) {
   const arr = fetchData();
   arr.splice(arr.indexOf(key), 1)
   if (arr.length) {
     localStorage.setItem(local_key, JSON.stringify(arr))
   } else {
     localStorage.removeItem(local_key)

   }
 }


 // 加载全量
 export function loadTotal() {
   return fetchData();
 }